<mat-form-field>
    <mat-label>{{placeholder}}</mat-label>
    <mat-chip-grid #chipGrid>
        <mat-chip-row *ngFor="let tag of tags" (removed)="remove(tag)">
            {{optionsDictionary[tag] && optionsDictionary[tag].display || tag}}
            <button matChipRemove>
                <mat-icon svgIcon="cancel"></mat-icon>
            </button>
        </mat-chip-row>
        <input matInput
            #tagInput
            [formControl]="tagControl"
            [matAutocomplete]="tagsAuto"
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="tagAdded($event)"
        (blur)="clearTagsInput()">
    <mat-autocomplete
     #tagsAuto="matAutocomplete"
     (optionSelected)="selected($event)"
     (closed)="clearTagsInput()">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option.value">
            {{option.display}}
        </mat-option>
        <mat-option disabled = "true" [value]="null">
                Press enter to add custom value
            </mat-option>
    </mat-autocomplete>
    </mat-chip-grid>
    
</mat-form-field>